import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Card, message, Spin } from 'antd';
import { getTenantProfile, registerTenant } from '../services/tenant-service';

const SettingsContainer = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [existingProfile, setExistingProfile] = useState(null);

  useEffect(() => {
    getTenantProfile()
      .then(res => {
        const data = res.data?.results?.[0] || res.data?.result || res.data;
        if (data && data.sellerId) {
          setExistingProfile(data);
          form.setFieldsValue({ sellerId: data.sellerId, displayName: data.displayName });
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [form]);

  const onFinish = async (values) => {
    setSaving(true);
    try {
      await registerTenant(values);
      message.success('Settings saved successfully');
    } catch (err) {
      message.error('Failed to save settings: ' + (err.response?.data?.message || err.message));
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div style={{ padding: 50, textAlign: 'center' }}><Spin size="large" /></div>;

  return (
    <Card title="Kogan API Settings" style={{ maxWidth: 600, margin: '20px auto' }}>
      {existingProfile && (
        <Card type="inner" title="Current Profile" style={{ marginBottom: 16 }}>
          <p><strong>Store:</strong> {existingProfile.displayName}</p>
          <p><strong>Seller ID:</strong> {existingProfile.sellerId}</p>
          <p><strong>Token:</strong> {existingProfile.sellerToken}</p>
        </Card>
      )}
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item name="sellerId" label="Seller ID" rules={[{ required: true, message: 'Please enter your Kogan Seller ID' }]}>
          <Input placeholder="Your Kogan seller ID" />
        </Form.Item>
        <Form.Item name="sellerToken" label="Seller Token" rules={[{ required: true, message: 'Please enter your Kogan API token' }]}>
          <Input.Password placeholder="Your Kogan API token" />
        </Form.Item>
        <Form.Item name="displayName" label="Display Name" rules={[{ required: true, message: 'Please enter your store name' }]}>
          <Input placeholder="Your store display name" />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={saving} block>
            {existingProfile ? 'Update Settings' : 'Save Settings'}
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default SettingsContainer;
